import { KmsDto, RootwiseCostResponseModel, RouteCostIdreq, VehicleReqId} from "@project-management-system/shared-models";
import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";


export class RootWiseCostService extends CommonAxiosService {
    private RootWiseCostController = "/rootwisecost";

    async createRootWisecost(payload: any): Promise<RootwiseCostResponseModel> {
        // console.log(payload,"fffffffffffff");
        return this.axiosPostCall(this.RootWiseCostController + "/createRootwisecost", payload)
    }

    async getAllRootwiseCostInfo(req?:RouteCostIdreq): Promise<RootwiseCostResponseModel> {
        return this.axiosPostCall(this.RootWiseCostController + "/getAllRootwiseCostInfo",req)
    }

    async getAllActiveRootWiseCostInfo(): Promise<RootwiseCostResponseModel> {
        return this.axiosPostCall(this.RootWiseCostController + "/getAllActiveRootWiseCostInfo")
    }
    async updateRootwisecost(dto: any): Promise<RootwiseCostResponseModel> {
        return await this.axiosPostCall(this.RootWiseCostController + '/updateRootwisecost', dto)
    }

    async activateOrDeactivateRootwiseCost(payload: any): Promise<RootwiseCostResponseModel> {
        return this.axiosPostCall(this.RootWiseCostController + "/activateOrDeactivateRootwiseCost", payload)
    }

    async getCost(payload: KmsDto): Promise<RootwiseCostResponseModel> {
        return this.axiosPostCall(this.RootWiseCostController + "/getCost", payload)
    }

    async getExactSlabCost(payload: KmsDto): Promise<RootwiseCostResponseModel> {
        return this.axiosPostCall(this.RootWiseCostController + "/getExactSlabCost", payload)
    }


    async getRouteById(payload: VehicleReqId): Promise<RootwiseCostResponseModel> {
        return this.axiosPostCall(this.RootWiseCostController + "/getRouteById", payload)
    }
    async vehcileTypeFromrootwisecost(): Promise<RootwiseCostResponseModel> {
        return this.axiosPostCall(this.RootWiseCostController + "/vehcileTypeFromrootwisecost")
    }
    

}